export const EMAIL_LABEL = "email";
export const PASSWORD_LABEL = "password";
export const REGION_LABEL = "region";